<template>
    <div class="get-more-info">
        <div class="form-container">
            <div class="agent-info" v-if="agentInfo">
                <AgentHeadShot class="agent-image" :agent="agentInfo" dir="width" />

                <div class="agent-des">
                    <div class="agent-name">{{ agentInfo.fullName }}</div>
                    <p class="tips">
                        {{ agentInfo.position }}
                        <span v-if="agentInfo.position && agentInfo.license">
                            | {{ licenseName || $t('md-detail-info.licenseId')
                            }}{{ agentInfo.license }}
                        </span>
                    </p>
                    <p v-if="agentInfo.phone" class="tips">
                        <a
                            :href="'tel:' + agentInfo.phone"
                            target="_top"
                            rel="noopener noreferrer"
                        >{{ $ft.formatPhone(agentInfo.phone) }}</a>
                    </p>
                </div>
            </div>
            <div class="form-content">
                <h2 class="title">{{ soldFormTitle }}</h2>
                <v-form
                    :onSubmit="registerSubmit"
                    :onSuccess="registerSubmitSuccess"
                    :onError="registerSumbitError"
                    ref="form"
                >
                    <input-item
                        v-for="(item, index) in items"
                        :item="item"
                        :key="index"
                    />
                    <input
                        type="submit"
                        :value="soldFormButtonText"
                        :disabled="submitDisabled"
                        :class="{ 'submit-disabled': submitDisabled }"
                    />
                </v-form>
                <div
                    class="privacy-text"
                    v-html="$t('md-detail-info.weRespectYourPrivacy')"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState as rootMapState } from 'pinia';
import { mapState } from '@/store/helpers';
import { usePageStore } from '@/store';
import util from '@/common/util';
import inputItem from '../../../components/input-item.vue';
import vForm from '../../../components/v-form.vue';
import message from '../../../mixins/message';
import { openLoginHideOtherPop } from '@/components/sign-log';
export default {
    i18next: {
        ns: 'md-detail-info'
    },
    components: { inputItem, vForm },
    mixins: [message],
    data: function() {
        return {
            approveChecked: true,
            submitDisabled: false
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            "licenseName": store => store.page?.licenseName
        }),
        ...mapState({
            "agentInfo": "agentInfo",
            "soldFormTitle": "soldFormTitle",
            "soldFormButtonText": "soldFormButtonText",
            "soldFormNameFormat": "soldFormNameFormat",
            "soldFormPhoneRequired": "soldFormPhoneRequired"
        }),
        items() {
            let readonly = !!this.user;
            let nameitems = [];
            if (this.soldFormNameFormat == 'full') {
                nameitems = [
                    {
                        name: 'fullname',
                        placeholder: this.$t('md-detail-info.fullName'),
                        defaultValue: '',
                        type: 'text',
                        readonly: readonly,
                        value: this.user ? this.user.fullName : ''
                    }
                ];
            } else {
                nameitems = [
                    {
                        name: 'firstName',
                        placeholder: this.$t('md-detail-info.firstName'),
                        type: 'text',
                        readonly: readonly,
                        value: (this.user && this.user.firstName) || ''
                    },
                    {
                        name: 'lastName',
                        placeholder: this.$t('md-detail-info.lastName'),
                        type: 'text',
                        readonly: readonly,
                        value: (this.user && this.user.lastName) || ''
                    }
                ];
            }
            let items = nameitems.concat([
                {
                    name: 'email',
                    placeholder: this.$t('md-detail-info.email') + '*',
                    defaultValue: '',
                    type: 'email',
                    readonly: readonly,
                    required: true,
                    value: this.user ? this.user.account : '',
                    validateConfig: {
                        async: '/api-site/register/hasUser?account={value}',
                        'async-callback': this.hasUserCallBack
                    }
                },
                {
                    name: 'phone',
                    placeholder:
                        this.$t('md-detail-info.phone') +
                        (this.soldFormPhoneRequired ? '*' : ''),
                    defaultValue: '',
                    type: 'tel',
                    required: this.soldFormPhoneRequired,
                    readonly: this.user && this.user.phoneNumber ? true : false,
                    value: this.user ? this.user.phoneNumber : '',
                    validateConfig: {
                        async: '/api-site/phoneValidate?phoneNumber={value}'
                    }
                },
                {
                    name: 'question',
                    placeholder:
                        this.$t('md-detail-info.message') +
                        (this.user ? '*' : ''),
                    defaultValue: '',
                    tag: 'textarea',
                    required: !!this.user
                }
            ]);

            return items;
        }
    },
    methods: {
        approveCheck() {
            this.approveChecked = !this.approveChecked;
        },
        registerSubmitSuccess(data = {}) {
            this.submitDisabled = true;
            setTimeout(() => {
                this.submitDisabled = false;
            }, 3000);
            this.formatData(data);
            if (this.user) {
                this.leaveMessage(this.onSuccessCallback);
            } else {
                this.leadRegister();
            }
        },
        registerNext() {
            if (this.inquiry) {
                this.showQuestionnaire(
                    Object.assign({}, this.questionnaire || {}, {
                        noToast: true,
                        closeCallback: () => {
                            this.onSuccessCallback();
                        }
                    })
                );
            } else {
                this.onSuccessCallback();
            }
        },
        onSuccessCallback() {
            util.toast(
                (this.onSubmitOption && this.onSubmitOption.toastMsg) ||
                    this.$t('md-detail-info.thanksIllGetBackTo'),
                (this.onSubmitOption && this.onSubmitOption.toastDelay) || 2000
            );
            if (this.$refs.form) {
                this.$refs.form.reset({
                    question: ''
                });
            }
        },
        hasUserCallBack(flag, error, value) {
            if (
                !flag && error?.code === 210003
            ) {
                setTimeout(() => {
                    openLoginHideOtherPop({}, value);
                }, 1000);
            }
        }
    }
};
</script>
<style lang="scss">
@import '@/theme/mixin.scss';
.md-detail-info.standard {
    .get-more-info {
        .form-container {
            background-color: #f8f9fd;
            .agent-info {
                display: flex;
                padding: 30px 40px 20px 40px;
                border-bottom: 1px solid white;
                .agent-image {
                    height: 64px !important;
                    width: 64px !important;
                    margin-right: 16px;
                    flex: 0 0 auto;
                    img {
                        border-radius: 50%;
                    }
                }
                .agent-name {
                    font-size: 18px;
                    color: #202437;
                    font-family: var(--font-bold);
                    margin-bottom: 10px;
                }
                .tips {
                    font-size: 12px;
                    color: #515666;
                }
            }
            .form-content {
                padding: 20px 40px 40px 40px;
                .title {
                    font-size: 14px;
                    font-family: var(--font-bold);
                    margin-bottom: 10px;
                }
                form {
                    display: flex;
                    flex-wrap: wrap;
                    input[type='text'],
                    input[type='email'],
                    input[type='tel'] {
                        border: none;
                        color: #778099;
                        padding-left: 10px;
                        height: 40px;
                        font-size: 12px;
                        width: 100%;
                        margin-top: 10px;
                        border: 1px solid #ebecf1;
                    }
                    textarea {
                        height: 100px;
                        color: #778099;
                        padding: 12px 0 12px 10px;
                        border: none;
                        font-size: 14px;
                        width: 100%;
                        margin-top: 10px;
                    }
                    input[type='submit'] {
                        @include color-button-hover();
                        max-width: 100%;
                        padding: 12px 22px;
                        margin-top: 20px;
                        margin-bottom: 20px;
                        height: 40px;
                        @include color-button();
                        text-align: center;
                        font-size: 16px;
                        font-family: var(--font-medium);
                    }
                    input[disabled='disabled'].submit-disabled {
                        @include input-disabled();
                    }
                    .input-box {
                        width: 100%;
                    }
                    .firstName,
                    .lastName {
                        width: calc(50% - 10px);
                    }
                    .firstName {
                        margin-right: 20px;
                    }
                }
                .privacy-text {
                    color: #8b93a7;
                    line-height: 18px;
                    font-size: 12px;
                    a {
                        color: var(--color-link, var(--color-theme, #03c9ff));
                        text-decoration: underline;
                    }
                }
            }
        }
    }
}
</style>
